export default __webpack_public_path__ + "static/media/office2-afterB-480w.8fcd10c2.avif";